module.exports = __webpack_public_path__ + "static/img/risk-icon1.7b1983d5.png";